/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：237
 */

module.exports = {
  container: "BuckSelect_container__1qXsi",
  leftSelect: "BuckSelect_leftSelect__2jCru",
  rightSelected: "BuckSelect_rightSelected__26LIN",
  optionIcon: "BuckSelect_optionIcon__3bEPE",
  searchInputBox: "BuckSelect_searchInputBox__iGMZE",
  searchInput: "BuckSelect_searchInput__1UaJs",
  renderSelectBox: "BuckSelect_renderSelectBox__5sBar",
  addedTitle: "BuckSelect_addedTitle__3d53q",
  categoryIcon: "BuckSelect_categoryIcon__1uSoS",
  closeIcon: "BuckSelect_closeIcon__1G_5W",
  type: "BuckSelect_type__1ia9R",
  icon: "BuckSelect_icon__3RSbi",
  text: "BuckSelect_text__2Rhx1",
  option: "BuckSelect_option__1EEu8",
  name: "BuckSelect_name__2BXyp",
  screenIcon: "BuckSelect_screenIcon__2Ce1N",
  checkbox: "BuckSelect_checkbox__3zsfe",
  screenTitle: "BuckSelect_screenTitle__3Onck",
  screenIconBox: "BuckSelect_screenIconBox__z55mV",
  screenTitleText: "BuckSelect_screenTitleText__3jfCa",
  selectedBox: "BuckSelect_selectedBox__3W2Se",
  screenInfoBox: "BuckSelect_screenInfoBox__MwGQm",
  selectedItems: "BuckSelect_selectedItems__1znV0",
  actions: "BuckSelect_actions__1CIgm",
  empty: "BuckSelect_empty__2LDfx",
  nameText: "BuckSelect_nameText__1IexY"
}
